import type { EncodeStatusEnum } from '@frameio/graphql-client/generated';

export type EncodeStatus = {
  encodeStatus: EncodeStatusEnum;
  key: string;
};

export function hasSuccessfulTranscodes(
  transcodes: Array<EncodeStatus>
): boolean {
  return transcodes.some(
    ({ encodeStatus }) =>
      encodeStatus === 'SUCCESS' || encodeStatus === 'WARNING'
  );
}
